import React, { useEffect, useState } from 'react'
import NavbarPOS from './NavbarPOS'
// import Sidebar from "./Sidebar";
import { useSelector } from 'react-redux'
import useDebounce from '../components/Hooks/useDebounce'
import MenuService from '../services/menuService'
import { isEmpty } from '../utils/common'
import { identifyVenue, trackEvent } from '../utils/mixpanelUtil'
import FoodCheckout from '../views/POS/FoodCheckout'
import FooterPOS from './FooterPOS'
import './index.css'
import SidebarPOSFood from './SidebarPOSFood'

export default function LayoutPOSFood() {
	const { short_code } = useSelector((state) => state.app)

	const [data, setData] = useState([])
	const [loaded, setLoaded] = useState(false)
	const [search, setSearch] = useState('')
	const debouncedValue = useDebounce(search, 900)

	const [updateCart, setUpdateCart] = useState(false)

	useEffect(() => {
		refreshData()
		// eslint-disable-next-line
	}, [debouncedValue])

	const refreshData = () => {
		let query = []
		if (!isEmpty(debouncedValue)) {
			query.push(`search=${debouncedValue}`)
		}

		MenuService.getProducts(query.join('&'), short_code)
			.then((res) => {
				setLoaded(true)
				setData(res?.products || [])
				identifyVenue(short_code)
				trackEvent('Products List POS', {
					action_category: 'load',
					action_outcome: 'success',
					interaction_element: 'screen',
				})
			})
			.catch((err) => {
				setLoaded(true)
				identifyVenue(short_code)
				trackEvent('Products List POS', {
					action_category: 'load',
					action_outcome: 'failed',
					interaction_element: 'product',
				});
				throw new Error("Problem retrieving Products List for POS Food non-mobile");
			})
	}

	return (
		<div className="flex flex-row w-full h-full">
			<div className="flex flex-col w-full justify-between flex-1 h-full">
				<div>
					<NavbarPOS />
				</div>
				<div className="flex flex-1 h-full">
					<FoodCheckout list={data} setUpdateCart={setUpdateCart} />
				</div>
				<div>
					<FooterPOS />
				</div>
			</div>
			<div className="flex  h-full">
				<SidebarPOSFood updateCart={updateCart} setUpdateCart={setUpdateCart} />
			</div>
		</div>
	)
}
